// src/serviceWorkerRegistration.js

// Este es el código original de tu archivo
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // La URL del Service Worker se maneja con PUBLIC_URL.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Nuestro service-worker.js está en una ruta diferente a publicUrl.
      // Esto significa que los activos no se servirán desde la caché del Service Worker.
      // Puedes eliminarlos y registrar un nuevo Service Worker para que todo funcione.
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Esto se está ejecutando en localhost. Verifiquemos si un service worker ya existe.
        checkValidServiceWorker(swUrl, config);

        // Agrega algunos logs adicionales a la consola para desarrolladores en localhost.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'Esta aplicación web está siendo servida fuera de línea por un service worker. ' +
              'Para más detalles, visita https://cra.link/PWA'
          );
        });
      } else {
        // No en localhost. Solo registra el service worker.
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      // ** MODIFICACIONES AQUÍ **

      // Escuchar el evento 'updatefound' cuando se encuentre una nueva versión del SW
      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // En este punto, la nueva versión del Service Worker se ha instalado
              // y está esperando para activarse.
              // Envía un mensaje al nuevo Service Worker para que se salte la espera
              installingWorker.postMessage({ type: 'SKIP_WAITING' });

              // Llama a la devolución de llamada (callback) de actualización si está configurada
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // En este punto, todo está precacheado, pero no hay un Service Worker
              // anterior que tome el control.
              // Llama a la devolución de llamada de éxito si está configurada
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        });
      });

      // ** NUEVA LÓGICA PARA FORZAR RECARGA DESPUÉS DE QUE EL NUEVO SW TOME EL CONTROL **
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Un nuevo Service Worker ha tomado el control. Recargando la página...');
        window.location.reload(); // Forzar la recarga de la página
      });

    })
    .catch(error => {
      console.error('Error durante el registro del service worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}